import type { Customer } from "@/components/CustomersFacilitiesTable"
import { Facility } from "@/types/facility"

export type FormField =
   | keyof Omit<Customer, "facilities">
   | keyof Facility
   | keyof Facility["address"]

export interface FormFieldConfig {
   placeholder: string
   validate: (value: string) => boolean
}

const VALIDATION_PATTERNS = {
   TEXT: /^.*$/,
   NUMBER: /^[0-9\s-]+$/,
   TEXT_AND_NUMBER: /^.*$/,
   ENTRA_TID: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
}

export const fieldConfig: Partial<Record<FormField, FormFieldConfig>> = {
   customerName: {
      placeholder: "* Customer",
      validate: (value) =>
         VALIDATION_PATTERNS.TEXT.test(value) &&
         value.length > 0 &&
         value.trim() === value &&
         value.trim().length > 0,
   },
   name: {
      placeholder: "* Facility",
      validate: (value) =>
         VALIDATION_PATTERNS.TEXT.test(value) &&
         value.length > 0 &&
         value.trim() === value &&
         value.trim().length > 0,
   },
   country: {
      placeholder: "* Country",
      validate: (value) =>
         VALIDATION_PATTERNS.TEXT.test(value) &&
         value.length > 0 &&
         value.trim() === value &&
         value.trim().length > 0,
   },
   state: {
      placeholder: "State",
      validate: (value) => VALIDATION_PATTERNS.TEXT.test(value),
   },
   city: {
      placeholder: "City",
      validate: (value) =>
         typeof value === "string" &&
         value.length > 0 &&
         VALIDATION_PATTERNS.TEXT.test(value),
   },
   street: {
      placeholder: "Street",
      validate: (value) =>
         typeof value === "string" &&
         value.length > 0 &&
         VALIDATION_PATTERNS.TEXT_AND_NUMBER.test(value),
   },
   zipCode: {
      placeholder: "Zip",
      validate: (value) =>
         typeof value === "string" &&
         value.length > 0 &&
         VALIDATION_PATTERNS.TEXT_AND_NUMBER.test(value),
   },
   entraTid: {
      placeholder: "Entra ID",
      validate: (value) =>
         typeof value === "string" &&
         (value === "" || VALIDATION_PATTERNS.ENTRA_TID.test(value)),
   },
}
